var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M31.4869 12H23.462V0H11.4247V12H3.3999L17.4434 26L31.4869 12ZM3.3999 30V34H31.4869V30H3.3999Z","fill":"#B36CF1"}));
}

Download.defaultProps = {"viewBox":"0 0 34 34","fill":"none"};

module.exports = Download;

Download.default = Download;
